module.exports = __webpack_public_path__ + "static/media/gjensidige.befaf42f.svg";